import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=523619eb&scoped=true&"
import script from "./GalleryList.vue?vue&type=script&lang=js&"
export * from "./GalleryList.vue?vue&type=script&lang=js&"
import style0 from "./GalleryList.vue?vue&type=style&index=0&id=523619eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523619eb",
  null
  
)

export default component.exports